import type { FC } from 'react';
import { PrivacyStyles as styles } from '../css/styles';
import { useTranslation } from 'react-i18next';
import { Helmet } from "react-helmet-async";

const Privacy: FC = () => {
  const { t } = useTranslation();
    return (
      <>
        <Helmet>
          <title>{t(`meta.privacy.title`)}</title>
          <meta name="description" content={t(`meta.privacy.description`)} />
        </Helmet>
        <div className={styles.privacyContainer}>
          <h1>{t(`privacy.title`)}</h1>
          <p><strong>{t(`privacy.dateMsg`)}</strong> [Insert Date]</p>
    
          <h2>{t(`privacy.sections.one.title`)}</h2>
          <p>{t(`privacy.sections.one.msg`)}</p>
    
          <h2>{t(`privacy.sections.two.title`)}</h2>
          <ul>
            <li>{t(`privacy.sections.two.msg1`)}</li>
            <li>{t(`privacy.sections.two.msg2`)}</li>
            <li>{t(`privacy.sections.two.msg3`)}</li>
          </ul>
    
          <h2>{t(`privacy.sections.three.title`)}</h2>
          <p>{t(`privacy.sections.three.msg`)}</p>
    
          <h2>{t(`privacy.sections.four.title`)}</h2>
          <p>{t(`privacy.sections.four.msg`)}</p>
    
          <h2>{t(`privacy.sections.five.title`)}</h2>
          <p>{t(`privacy.sections.five.msg`)}</p>
    
          <h2>{t(`privacy.sections.six.title`)}</h2>
          <p>{t(`privacy.sections.six.msg`)}</p>
    
          <h2>{t(`privacy.sections.seven.title`)}</h2>
          <p>{t(`privacy.sections.seven.msg`)}</p>
    
          <h2>{t(`privacy.sections.eight.title`)}</h2>
          <p>{t(`privacy.sections.eight.msg`)}</p>
    
          <h2>{t(`privacy.sections.nine.title`)}</h2>
          <p>{t(`privacy.sections.nine.msg`)}</p>
        </div>
      </>
      
    );
  };
  
  export default Privacy;